module.exports = __webpack_public_path__ + "static/all-praise-to-our-redeeming-lord-01-e125d3e917f5b72e34030179e477d47a.png";